import { Collapsible, IconChevronDown, IconChevronUp, ProgressStepper } from '@zillow/constellation';
import { TextButton } from '@zillow/constellation-10';

type Signee = {
  type: string;
  text: string;
};
type Props = {
  text: string;
  signeeList: Array<Signee>;
};

const WhoHasSignedDescription = ({ text, signeeList }: Props) => {
  function renderExpandedContent(): JSX.Element | null {
    if (signeeList == null) {
      return null;
    }

    const isComplete = signeeList.every((signee) => signee.type !== 'unsigned');

    const steps = signeeList.map((signee) => ({
      label: signee.text,
      appearance: signee.type !== 'unsigned' ? 'complete' : null,
    }));

    return (
      <ProgressStepper activeStepIndex={isComplete ? signeeList?.length : -1} orientation="vertical" steps={steps} />
    );
  }

  return (
    <>
      {signeeList?.length > 0 && (
        <Collapsible
          // eslint-disable-next-line react/no-children-prop
          children={(collapsed: boolean, onToggleExpansion: () => void) => (
            <div>
              <TextButton
                icon={collapsed ? <IconChevronDown /> : <IconChevronUp />}
                onClick={onToggleExpansion}
                iconPosition="end"
                css={{ marginBottom: collapsed ? 0 : '200' }}
              >
                Who has signed?
              </TextButton>
              {collapsed ? null : renderExpandedContent()}
            </div>
          )}
        />
      )}
    </>
  );
};

export default WhoHasSignedDescription;
